module.exports = __webpack_public_path__ + "static/media/Dining1.2ed5626a.jpg";